export const setPaginationRange = (start, end) => {
    const length = end - start + 1;
    return Array.from({ length }, (_, i) => start + i);
};
export const leftFillNumber = (number, targetLength) => number.toString().padStart(targetLength, '0');
//# sourceMappingURL=Pagination.helpers.js.map